import React, { useState, useEffect } from "react";
import axios from "axios";
import toastr from "../../../utils/toast";

function EditDescriptionModal({
  show,
  onClose,
  roleId,
  currentDescription,
  token,
  refreshData,
}) {
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Sync description when modal opens or currentDescription changes
  useEffect(() => {
    if (show) {
      setDescription(currentDescription || "");
    }
  }, [show, currentDescription]);

  const handleSave = async () => {
    if (!description.trim()) {
      alert("Description cannot be empty");
      return;
    }

    try {
      setSaving(true);
      const descriptionupdate = await axios.put(
        `${API_BASE_URL}/roles/update_description/${roleId}`,
        { description },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (descriptionupdate.status === 200) {
        toastr.success("Description updated!");
      } else {
        toastr.error("Something went wrong ");
      }
      refreshData(); // Refresh role data
      onClose();
    } catch (error) {
      console.error("Failed to update description:", error);
      alert("Failed to update");
    } finally {
      setSaving(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Role Description</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <textarea
              className="form-control"
              rows="5"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter role description"
            />
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditDescriptionModal;
